<template lang="pug">
.rating-box
    .rating-box-title(v-if="label") {{ label }}
    .rating-value(:style="{ color: pickTextOn(getRatingColor(value)), backgroundColor: getRatingColor(value) || '#FFFFFF' }") {{ value }}
</template>

<script lang="ts">
import { getRatingColor } from "@/helpers";
import {pickTextOn} from "@/helpers/font-contrast";

export default {
  props: {
    label: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      getRatingColor,
      pickTextOn,
    };
  },
};
</script>

<style lang="scss" scoped>
.rating-box {
  border: solid 1;
  display: flex;
  align-items: stretch;
  padding: 0.5rem 0.75rem;
  .rating-box-title {
    display: flex;
    align-items: center;
    background-color: white;
    border: solid 1px #d7d7d7;
    padding: 0.25rem 0.75rem;
    font-size: 0.8rem;
  }
  .rating-value {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    font-weight: 500;
    min-width: 2.5rem;
    padding: 0.25rem 0.75rem;
  }
}
</style>
